export default __webpack_public_path__ + "static/media/gallery_05.663e6281.jpg";